/* 🤖 this file was generated by svg-to-ts */
export const siriusPencilRuler: {
  name: 'pencil_ruler';
  data: string;
} = {
  name: 'pencil_ruler',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M19.5 3H15a1.5 1.5 0 0 0-1.5 1.5v15A1.5 1.5 0 0 0 15 21h4.5a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3Zm0 16.5H15v-3h2.25a.75.75 0 1 0 0-1.5H15v-2.25h2.25a.75.75 0 1 0 0-1.5H15V9h2.25a.75.75 0 1 0 0-1.5H15v-3h4.5v15ZM7.28 2.47a.75.75 0 0 0-1.06 0l-3 3A.75.75 0 0 0 3 6v13.5A1.5 1.5 0 0 0 4.5 21H9a1.5 1.5 0 0 0 1.5-1.5V6a.75.75 0 0 0-.22-.53l-3-3ZM4.5 16.5v-9H6v9H4.5Zm3-9H9v9H7.5v-9Zm-.75-3.44L8.69 6H4.81l1.94-1.94ZM4.5 19.5V18H9v1.5H4.5Z" fill="currentColor"/></svg>`
};
